<script>
import { Row, Col } from 'vant'
import TextSwitcher from '@/components/org/TextSwitcher'
import CheckboxCard from '@/components/org/CheckboxCard'
import ToggleButtonGroup from '@/components/org/ToggleButtonGroup'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-match-signup-team-config-edit',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-row': Row,
        'van-col': Col,
        'text-switcher': TextSwitcher,
        'checkbox-card': CheckboxCard,
        'toggle-button-group': ToggleButtonGroup,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            matchGroup: {
                id: null,
                isTeamNameChecked: null,
                isTeamShortNameChecked: null,
                isTeamContactChecked: null,
                isTeamContactPhoneChecked: null,
                isTeamEmblemChecked: null,
                isTeamDelegationChecked: null,
                teamDelegationItems: null,
                isTeamHomeColorChecked: null,
                isTeamAwayColorChecked: null,
                isTeamContestColorChecked: null,
                isTeamSuitStyleChecked: null,
                isTeamInsuranceChecked: null,
            },
            locale: {}
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onSaveBtnClick() {
            this.$emit('custom-event', {
                type: 'save',
                data: this.matchGroup
            })
        },
        onTeamShortNameDataChange(data) {
            if (data == this.matchGroup.isTeamShortNameChecked) {
                return
            }
            this.matchGroup.isTeamShortNameChecked = data
            this.submitData()
        },
        onTeamContactDataChange(data) {
            if (data == this.matchGroup.isTeamContactChecked) {
                return
            }
            this.matchGroup.isTeamContactChecked = data
            this.submitData()
        },
        onTeamContactPhoneDataChange(data) {
            if (data == this.matchGroup.isTeamContactPhoneChecked) {
                return
            }
            this.matchGroup.isTeamContactPhoneChecked = data
            this.submitData()
        },
        onTeamEmblemDataChange(data) {
            if (data == this.matchGroup.isTeamEmblemChecked) {
                return
            }
            this.matchGroup.isTeamEmblemChecked = data
            this.submitData()
        },
        onTeamDelegationDataChange(data) {
            if (data == this.matchGroup.isTeamDelegationChecked) {
                return
            }
            this.matchGroup.isTeamDelegationChecked = data
            if (this.matchGroup.isTeamDelegationChecked == false) {
                // clear the items while team delegation not checked
                this.matchGroup.teamDelegationItems = []
            }
            this.submitData()
        },
        onTeamDelegationItemDataChange(data) {
            console.log('onTeamDelegationItemDataChange', data)
            this.matchGroup.teamDelegationItems = data
            this.submitData()
        },
        onTeamHomeColorDataChange(data) {
            if (data == this.matchGroup.isTeamHomeColorChecked) {
                return
            }
            this.matchGroup.isTeamHomeColorChecked = data
            this.submitData()
        },
        onTeamAwayColorDataChange(data) {
            if (data == this.matchGroup.isTeamAwayColorChecked) {
                return
            }
            this.matchGroup.isTeamAwayColorChecked = data
            this.submitData()
        },
        onTeamContestColorDataChange(data) {
            if (data == this.matchGroup.isTeamContestColorChecked) {
                return
            }
            this.matchGroup.isTeamContestColorChecked = data
            this.submitData()
        },
        onTeamInsuranceDataChange(data) {
            if (data == this.matchGroup.isTeamInsuranceChecked) {
                return
            }
            this.matchGroup.isTeamInsuranceChecked = data
            this.submitData()
        },
        submitData() {
            console.log('submit data', this.matchGroup)
            this.$emit('custom-event', {
                type: 'submit',
                data: this.matchGroup
            })
        },
    },
}
</script>

<template>
    <div class="match-signup-team-config-edit">
        <div class="nav-op-bar fixed-top">
            <van-row class="hp100 vertical-center">
                <van-col 
                    class="main-text primary-color text-right u-inner-padding" 
                    span="24"
                    @click="onSaveBtnClick">
                    {{ locale['confirm'] }}
                </van-col>
            </van-row>
        </div>
        <div class="main-fields">
            <text-switcher 
                :label="locale['signup-team-config-type-1']"
                :checked="matchGroup.isTeamNameChecked"
                :readonly="true"
            />
            <text-switcher 
                :label="locale['signup-team-config-type-2']"
                :checked="matchGroup.isTeamShortNameChecked"
                @change-data="onTeamShortNameDataChange"
            />
            <text-switcher 
                :label="locale['signup-team-config-type-3']"
                :checked="matchGroup.isTeamContactChecked"
                @change-data="onTeamContactDataChange"
            />
            <text-switcher 
                :label="locale['signup-team-config-type-4']"
                :checked="matchGroup.isTeamContactPhoneChecked"
                @change-data="onTeamContactPhoneDataChange"
            />
            <text-switcher 
                :label="locale['signup-team-config-type-5']"
                :checked="matchGroup.isTeamEmblemChecked"
                @change-data="onTeamEmblemDataChange"
            />
            <text-switcher 
                :label="locale['signup-team-config-type-6']"
                :checked="matchGroup.isTeamDelegationChecked"
                :separated="false"
                @change-data="onTeamDelegationDataChange"
            />
            <toggle-button-group
                v-if="matchGroup.isTeamDelegationChecked"
                :items="matchGroup.teamDelegationItems"
                :input-mode="true"
                :input-label="locale['add']"
                :input-placeholder="locale['add-item-placeholder']"
                @change-data="onTeamDelegationItemDataChange"
            />
        </div>
        <div class="u-outer-padding">
            <span class="minor-text minor-color">{{ locale['other-data-item'] }}</span>
        </div>
        <div class="minor-fields">
            <van-row class="u-inner-padding" gutter="10">
                <van-col class="b-outer-margin" span="12">
                    <checkbox-card
                        :label="locale['signup-team-config-type-7']"
                        :description="locale['signup-team-config-type-7-desc']"
                        :checked="matchGroup.isTeamHomeColorChecked"
                        @change-data="onTeamHomeColorDataChange"
                    />
                </van-col>
                <van-col class="b-outer-margin" span="12">
                    <checkbox-card
                        :label="locale['signup-team-config-type-8']"
                        :description="locale['signup-team-config-type-8-desc']"
                        :checked="matchGroup.isTeamAwayColorChecked"
                        @change-data="onTeamAwayColorDataChange"
                    />
                </van-col>
                <van-col class="b-outer-margin" span="12">
                    <checkbox-card
                        :label="locale['signup-team-config-type-9']"
                        :description="locale['signup-team-config-type-9-desc']"
                        :checked="matchGroup.isTeamContestColorChecked"
                        @change-data="onTeamContestColorDataChange"
                    />
                </van-col>
                <van-col class="b-outer-margin" span="12">
                    <checkbox-card
                        :label="locale['signup-team-config-type-11']"
                        :description="locale['signup-team-config-type-11-desc']"
                        :checked="matchGroup.isTeamInsuranceChecked"
                        @change-data="onTeamInsuranceDataChange"
                    />
                </van-col>
            </van-row>
        </div>
    </div>
</template>